/* @flow weak */
const keyDown = {};

if (typeof document !== 'undefined') {
  document.addEventListener('keydown', function(event) {
    keyDown[event.keyCode] = true;
  }, false);

  document.addEventListener('keyup', function(event) {
    delete keyDown[event.keyCode];
  }, false);
}

export default {
  isKeyDown(code = null): boolean {
    return code === null ? Object.keys(keyDown).length > 0 : code in keyDown;
  },
};



// WEBPACK FOOTER //
// ./src/lib/KeyState.js